
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/page/[page]",
      function () {
        return require("private-next-pages/news/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/page/[page]"])
      });
    }
  